<template>
  <section class="hero is-bold app-navbar">
    <div class="hero-head">
      <nav class="nav">
        <div class="nav-left">
          <a class="nav-item touchable sidebar-toggle" @click="toggleSidebar">
            <span class="icon">
              <i class="fa fa-bars"></i>
            </span>
          </a>
          <a class="nav-item touchable sidebar-toggle" @click="toOldAdmin">
            <span class="button">
              去老后台
            </span>
          </a>
        </div>
        <div class="nav-center">
          <a class="nav-item hero-brand touchable" href="#">
            <img src="../../assets/top-logo.png" alt="CYZS Admin">
            <div class="is-hidden-mobile">
              <span class="vue">Admin</span><strong class="admin">System</strong>
            </div>
          </a>
        </div>
        <div class="nav-right is-flex"></div>
      </nav>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState({
        sidebar: state => state.sidebar
      })
  },
  mounted(){
    this.makeUserOnline();
  },
  methods: {
    ...mapActions([
      'setSidebarByVuex'
    ]),
    toggleSidebar () {
      let val = !this.sidebar.opened;
      this.setSidebarByVuex(val);
    },
    /**
     * 保证账号持续在线
     */
    makeUserOnline(){
      setInterval(()=>{
        HttpRequest.post("/admin.php?method=afk.ping");
      },60000)
    },
    toOldAdmin() {
      window.open("/admin.php");
    }
  }
}
</script>

<style lang="less">

.app-navbar {
  position: fixed;
  min-width: 100%;
  z-index: 1024;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

  .container {
    margin: auto 10px;
  }

  .nav-right {
    align-items: stretch;
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }

  .sidebar-toggle {
    &:hover {
      background: #f5f7fa;
    }
  }
}

.hero-brand {
  // text-indent: -3000px;
  .vue {
    margin-left: 10px;
    color: #36AC70;
  }
  .admin {
    color: #28374B;
  }
}
</style>
